module.exports = __webpack_public_path__ + "778d79d7dac6fe8876feaee87725484a.png";